App.DishSuggestionComponent = Em.Component.extend
  classNames: [ 'dish-suggestion' ]